// // src/actions/customsDeclarationActions.js

// import axiosInstance from '../utils/axiosInstance';
// import {
//     FETCH_DECLARATIONS_REQUEST,
//     FETCH_DECLARATIONS_SUCCESS,
//     FETCH_DECLARATIONS_FAILURE,
//     FETCH_DECLARATION_DETAILS_REQUEST,
//     FETCH_DECLARATION_DETAILS_SUCCESS,
//     FETCH_DECLARATION_DETAILS_FAILURE,
//     FETCH_GOODS_REQUEST,
//     FETCH_GOODS_SUCCESS,
//     FETCH_GOODS_FAILURE,
//     FETCH_CUSTOMS_DUTY_REQUEST,
//     FETCH_CUSTOMS_DUTY_SUCCESS,
//     FETCH_CUSTOMS_DUTY_FAILURE,
//     SAVE_DATA_REQUEST,
//     SAVE_DATA_SUCCESS,
//     SAVE_DATA_FAILURE,
//     SAVE_MULTIPLE_DECLARATIONS_REQUEST,
//     SAVE_MULTIPLE_DECLARATIONS_SUCCESS,
//     SAVE_MULTIPLE_DECLARATIONS_FAILURE,
//     SAVE_MULTIPLE_DECLARATIONS_PROGRESS,
//     FETCH_EXPORT_DECLARATIONS_REQUEST,
//     FETCH_EXPORT_DECLARATIONS_SUCCESS,
//     FETCH_EXPORT_DECLARATIONS_FAILURE,
// } from './actionTypes';

// // Synchronous Action Creators
// export const fetchDeclarationsRequest = () => ({
//     type: FETCH_DECLARATIONS_REQUEST,
// });

// export const fetchDeclarationsSuccess = (declarations) => ({
//     type: FETCH_DECLARATIONS_SUCCESS,
//     payload: declarations,
// });

// export const fetchDeclarationsFailure = (error) => ({
//     type: FETCH_DECLARATIONS_FAILURE,
//     payload: error,
// });
// export const fetchExportDeclarationsRequest = () => ({
//     type: FETCH_EXPORT_DECLARATIONS_REQUEST,
// });

// export const fetchExportDeclarationsSuccess = (declarations) => ({
//     type: FETCH_EXPORT_DECLARATIONS_SUCCESS,
//     payload: declarations,
// });

// export const fetchExportDeclarationsFailure = (error) => ({
//     type: FETCH_EXPORT_DECLARATIONS_FAILURE,
//     payload: error,
// });

// // Fetch Declaration Details Actions
// export const fetchDeclarationDetailsRequest = () => ({
//     type: FETCH_DECLARATION_DETAILS_REQUEST,
// });

// export const fetchDeclarationDetailsSuccess = (declarationDetails) => ({
//     type: FETCH_DECLARATION_DETAILS_SUCCESS,
//     payload: declarationDetails,
// });

// export const fetchDeclarationDetailsFailure = (error) => ({
//     type: FETCH_DECLARATION_DETAILS_FAILURE,
//     payload: error,
// });

// // Fetch Goods Actions
// export const fetchGoodsRequest = () => ({
//     type: FETCH_GOODS_REQUEST,
// });

// export const fetchGoodsSuccess = (goods) => ({
//     type: FETCH_GOODS_SUCCESS,
//     payload: goods,
// });

// export const fetchGoodsFailure = (error) => ({
//     type: FETCH_GOODS_FAILURE,
//     payload: error,
// });

// // Fetch Customs Duty Info Actions
// export const fetchCustomsDutyRequest = (ggsVcodeInt) => ({
//     type: FETCH_CUSTOMS_DUTY_REQUEST,
//     payload: ggsVcodeInt,
// });

// export const fetchCustomsDutySuccess = (ggsVcodeInt, dutyInfo) => ({
//     type: FETCH_CUSTOMS_DUTY_SUCCESS,
//     payload: { ggsVcodeInt, dutyInfo },
// });

// export const fetchCustomsDutyFailure = (ggsVcodeInt, error) => ({
//     type: FETCH_CUSTOMS_DUTY_FAILURE,
//     payload: { ggsVcodeInt, error },
// });

// // Save Data Actions
// export const saveDataRequest = () => ({
//     type: SAVE_DATA_REQUEST,
// });

// export const saveDataSuccess = (message) => ({
//     type: SAVE_DATA_SUCCESS,
//     payload: message,
// });

// export const saveDataFailure = (error) => ({
//     type: SAVE_DATA_FAILURE,
//     payload: error,
// });

// // Save Multiple Declarations Actions
// export const saveMultipleDeclarationsRequest = () => ({
//     type: SAVE_MULTIPLE_DECLARATIONS_REQUEST,
// });

// export const saveMultipleDeclarationsSuccess = (data) => ({
//     type: SAVE_MULTIPLE_DECLARATIONS_SUCCESS,
//     payload: data,
// });

// export const saveMultipleDeclarationsFailure = (error) => ({
//     type: SAVE_MULTIPLE_DECLARATIONS_FAILURE,
//     payload: error,
// });

// export const saveMultipleDeclarationsProgress = (current, total) => ({
//     type: SAVE_MULTIPLE_DECLARATIONS_PROGRESS,
//     payload: { current, total },
// });

// // Asynchronous Action Creators

// // Fetch Declarations
// export const fetchDeclarations = (ssdsshGUID, urlVCodeInt, pageSize, startIndex) => async (dispatch) => {
//     dispatch(fetchDeclarationsRequest());
//     const payload = {
//         ssdsshGUID,
//         urlVCodeInt: parseInt(urlVCodeInt, 10),
//         PageSize: parseInt(pageSize, 10),
//         StartIndex: parseInt(startIndex, 10),

//     };

//     try {
//         const response = await axiosInstance.post('customs-declarations/', payload);

//         if (response.data.ErrorCode === 0) {
//             const declarations = Array.isArray(response.data.CustomizeCustomsDeclarationList)
//                 ? response.data.CustomizeCustomsDeclarationList
//                 : [];
//             dispatch(fetchDeclarationsSuccess(declarations));
//         } else {
//             const errorMessage = response.data.ErrorDesc || 'An error occurred.';
//             dispatch(fetchDeclarationsFailure(errorMessage));
//         }
//     } catch (error) {
//         const errorMsg =
//             error.response && error.response.data
//                 ? error.response.data.ErrorDesc || error.response.data
//                 : 'Failed to connect to the server.';
//         dispatch(fetchDeclarationsFailure(errorMsg));
//     }
// };

// // Fetch Declaration Details
// export const fetchDeclarationDetails = (FullSerialNumber, ssdsshGUID, urlVCodeInt) => async (dispatch) => {
//     dispatch(fetchDeclarationDetailsRequest());
//     const payload = {
//         DeclarationType: 0,
//         FullSerilaNumber: FullSerialNumber,
//         ssdsshGUID,
//         urlVCodeInt: parseInt(urlVCodeInt, 10),
//     };

//     try {
//         const response = await axiosInstance.post('customs-green-declaration/', payload);

//         if (response.data.ErrorCode === 0) {
//             dispatch(fetchDeclarationDetailsSuccess(response.data.GreenCustomsDeclaration));
//         } else {
//             dispatch(fetchDeclarationDetailsFailure(response.data.ErrorDesc || 'An error occurred.'));
//         }
//     } catch (error) {
//         const errorMsg =
//             error.response && error.response.data
//                 ? error.response.data.ErrorDesc || error.response.data
//                 : 'Failed to connect to the server.';
//         dispatch(fetchDeclarationDetailsFailure(errorMsg));
//     }
// };

// // Fetch Goods
// export const fetchGoods = (gcuVcodeInt, ssdsshGUID, urlVCodeInt) => async (dispatch) => {
//     dispatch(fetchGoodsRequest());
//     const payload = {
//         gcuVcodeInt,
//         ssdsshGUID,
//         urlVCodeInt: parseInt(urlVCodeInt, 10),
//     };

//     try {
//         const response = await axiosInstance.post('fetch-goods/', payload);

//         if (response.data.ErrorCode === 0) {
//             const goods = Array.isArray(response.data.GreenCustomsDeclarationGoodList)
//                 ? response.data.GreenCustomsDeclarationGoodList.map((good) => ({
//                       ...good,
//                       import_rights: 0,
//                       red_cersent: 0,
//                       added_value: 0,
//                       discount: 0,
//                       customs_value: 0,
//                   }))
//                 : [];
//             dispatch(fetchGoodsSuccess(goods));
//         } else {
//             dispatch(fetchGoodsFailure(response.data.ErrorDesc || 'An error occurred.'));
//         }
//     } catch (error) {
//         const errorMsg =
//             error.response && error.response.data
//                 ? error.response.data.ErrorDesc || error.response.data
//                 : 'Failed to connect to the server.';
//         dispatch(fetchGoodsFailure(errorMsg));
//     }
// };

// // Fetch Customs Duty Information
// export const fetchCustomsDutyInformation = (ggsVcodeInt, ssdsshGUID, urlVCodeInt) => async (dispatch) => {
//     dispatch(fetchCustomsDutyRequest(ggsVcodeInt));
//     const payload = {
//         ggsVcodeInt,
//         ssdsshGUID,
//         urlVCodeInt: parseInt(urlVCodeInt, 10),
//     };

//     try {
//         const response = await axiosInstance.post('fetch-customs-duty-info/', payload);

//         if (response.data.ErrorCode === 0) {
//             const fetchedDutyInfo = response.data.GreenCustomsDutyInformationList || [];
//             const dutyInfo = {
//                 import_rights: fetchedDutyInfo.find((duty) => duty.cintaxesCode === '041')?.cintaxesAmount || 0,
//                 customs_value: fetchedDutyInfo.find((duty) => duty.cintaxesCode === '041')?.cintaxesBase || 0,
//                 red_cersent: fetchedDutyInfo.find((duty) => duty.cintaxesCode === '042')?.cintaxesAmount || 0,
//                 added_value: fetchedDutyInfo.find((duty) => duty.cintaxesCode === '047')?.cintaxesAmount || 0,
//                 discount: fetchedDutyInfo.find((duty) => duty.cintaxesCode === '049')?.cintaxesAmount || 0,
//             };
//             dispatch(fetchCustomsDutySuccess(ggsVcodeInt, dutyInfo));
//             return dutyInfo;
//         } else {
//             dispatch(
//                 fetchCustomsDutyFailure(ggsVcodeInt, response.data.ErrorDesc || 'An error occurred.')
//             );
//         }
//     } catch (error) {
//         const errorMsg =
//             error.response && error.response.data
//                 ? error.response.data.ErrorDesc || error.response.data
//                 : 'Failed to connect to the server.';
//         dispatch(fetchCustomsDutyFailure(ggsVcodeInt, errorMsg));
//     }
// };

// // Save Data
// export const saveData = (declaration, goods, ssdsshGUID, urlVCodeInt) => async (dispatch) => {
//     dispatch(saveDataRequest());

//     const formatDate = (dateString) => {
//         if (!dateString) return null;
//         const date = new Date(dateString);
//         const year = date.getFullYear();
//         const month = String(date.getMonth() + 1).padStart(2, '0');
//         const day = String(date.getDate()).padStart(2, '0');
//         return `${year}-${month}-${day}`;
//     };
    

//     const formattedCottageDate = formatDate(declaration.gcupreDeclarationDateSH);

//     const cottagePayload = {
//         cottage_number: declaration.gcucustomsDeclarationSerialNumber,
//         proforma: declaration.OrderRegistrationNumber,
//         cottage_date: formattedCottageDate,
//         total_value: declaration.gcutotalCurrencyValue,
//         quantity: declaration.gcucommodityItemQuantity,
//         refrence_number: declaration.gculCReferenceNumber,
//     };

//     try {
//         // Save the Cottage
//         const cottageResponse = await axiosInstance.post('save-cottage/', cottagePayload);

//         console.log('Cottage saved:', cottageResponse.data);

//         // Fetch and update duty info for all goods
//         const updatedGoodsPromises = goods.map(async (good) => {
//             const payload = {
//                 ggsVcodeInt: good.ggsVcodeInt,
//                 ssdsshGUID,
//                 urlVCodeInt: parseInt(urlVCodeInt, 10),
//             };

//             console.log('Sending payload to fetch-customs-duty-info:', payload);

//             const response = await axiosInstance.post('fetch-customs-duty-info/', payload);

//             if (response.data.ErrorCode === 0) {
//                 const fetchedDutyInfo = response.data.GreenCustomsDutyInformationList || [];
//                 return {
//                     ...good,
//                     import_rights: fetchedDutyInfo.find((duty) => duty.cintaxesCode === '041')?.cintaxesAmount || 0,
//                     customs_value: fetchedDutyInfo.find((duty) => duty.cintaxesCode === '041')?.cintaxesBase || 0,
//                     red_cersent: fetchedDutyInfo.find((duty) => duty.cintaxesCode === '042')?.cintaxesAmount || 0,
//                     added_value: fetchedDutyInfo.find((duty) => duty.cintaxesCode === '047')?.cintaxesAmount || 0,
//                     discount: fetchedDutyInfo.find((duty) => duty.cintaxesCode === '049')?.cintaxesAmount || 0,
//                 };
//             } else {
//                 console.error('Error from fetch-customs-duty-info API:', response.data.ErrorDesc);
//                 return good;
//             }
//         });

//         const updatedGoods = await Promise.all(updatedGoodsPromises);

//         console.log('Updated Goods with Duty Info:', updatedGoods);

//         // Prepare goods payload with updated duty info
//         const goodsPayload = {
//             cottage_number: declaration.gcucustomsDeclarationSerialNumber,
//             goods: updatedGoods.map((good) => ({
//                 ggsVcodeInt: good.ggsVcodeInt,
//                 ggscommodityItemNumber: good.ggscommodityItemNumber,
//                 ggscommodityDescription: good.ggscommodityDescription,
//                 total_value: good.ggscommodityItemCurrencyValue,
//                 import_rights: good.import_rights || 0,
//                 customs_value: good.customs_value || 0,
//                 red_cersent: good.red_cersent || 0,
//                 added_value: good.added_value || 0,
//                 discount: good.discount || 0,
//                 quantity: good.ggstotalItemCountInAllPackages,
//             })),
//         };

//         console.log('Goods Payload:', goodsPayload);

//         // Save the Goods
//         const goodsResponse = await axiosInstance.post('save-cottage-goods/', goodsPayload);

//         dispatch(
//             saveDataSuccess(
//                 goodsResponse.data.message || 'Goods and cottage saved successfully.'
//             )
//         );
//     } catch (error) {
//         console.error('Error during save operation:', error);

//         const errorMsg =
//             error.response && error.response.data
//                 ? error.response.data.ErrorDesc || JSON.stringify(error.response.data)
//                 : 'Error saving data.';

//         dispatch(saveDataFailure(errorMsg));
//     }
// };
// export const saveMultipleDeclarations = (declarations, ssdsshGUID, urlVCodeInt) => async (dispatch, getState) => {
//     dispatch(saveMultipleDeclarationsRequest({ total: declarations.length }));

//     let failedDeclarations = [];
//     let savedCount = 0;

//     for (const [index, declaration] of declarations.entries()) {
//         try {
//             // Fetch declaration details
//             await dispatch(fetchDeclarationDetails(declaration.FullSerialNumber, ssdsshGUID, urlVCodeInt));
//             const stateAfterDetails = getState().customsDeclarations;
//             if (stateAfterDetails.errorDeclarationDetails) {
//                 throw new Error(`Failed to fetch details: ${stateAfterDetails.errorDeclarationDetails}`);
//             }

//             // Fetch goods
//             await dispatch(fetchGoods(stateAfterDetails.declarationDetails.gcuVcodeInt, ssdsshGUID, urlVCodeInt));
//             const stateAfterGoods = getState().customsDeclarations;
//             if (stateAfterGoods.errorGoods) {
//                 throw new Error(`Failed to fetch goods: ${stateAfterGoods.errorGoods}`);
//             }

//             // Save data
//             await dispatch(saveData(stateAfterGoods.declarationDetails, stateAfterGoods.goods, ssdsshGUID, urlVCodeInt));
//             const finalState = getState().customsDeclarations;
//             if (finalState.saveError) {
//                 throw new Error(`مورد ذخیره نشد: ${finalState.saveError}`);
//             }

//             // If everything succeeded
//             savedCount++;
//         } catch (error) {
//             // Store both the declaration serial and the reason it failed
//             failedDeclarations.push({
//                 FullSerialNumber: declaration.FullSerialNumber,
//                 reason: error.message || 'An unknown error occurred.'
//             });
//             console.error(`Error saving declaration: ${declaration.FullSerialNumber}`, error);
//         }

//         // Update progress
//         dispatch(saveMultipleDeclarationsProgress(index + 1, declarations.length));
//     }

//     // Construct the final message
//     let message;
//     if (savedCount === declarations.length) {
//         message = 'All declarations saved successfully.';
//     } else {
//         message = `${savedCount}/${declarations.length} اضهارنامه های ثبت شده. ${failedDeclarations.length} ثبت نشده.`;
//     }

//     dispatch(saveMultipleDeclarationsSuccess({ message, failedDeclarations }));
// };
// export const fetchExportDeclarations = (ssdsshGUID, urlVCodeInt, pageSize, startIndex) => async (dispatch) => {
//     dispatch(fetchExportDeclarationsRequest());
//     const payload = {
//         ssdsshGUID,
//         urlVCodeInt: parseInt(urlVCodeInt, 10),
//         PageSize: parseInt(pageSize, 10),
//         StartIndex: parseInt(startIndex, 10),

//     };

//     try {
//         const response = await axiosInstance.post('export-customs-declarations/', payload);

//         if (response.data.ErrorCode === 0) {
//             const declarations = Array.isArray(response.data.CustomizeCustomsDeclarationList)
//                 ? response.data.CustomizeCustomsDeclarationList
//                 : [];
//             dispatch(fetchExportDeclarationsSuccess(declarations));
//         } else {
//             const errorMessage = response.data.ErrorDesc || 'An error occurred.';
//             dispatch(fetchExportDeclarationsFailure(errorMessage));
//         }
//     } catch (error) {
//         const errorMsg =
//             error.response && error.response.data
//                 ? error.response.data.ErrorDesc || error.response.data
//                 : 'Failed to connect to the server.';
//         dispatch(fetchExportDeclarationsFailure(errorMsg));
//     }
// };
// // New Action Creator: Save Multiple Declarations
// export const saveSelectedDeclarations = (ssdsshGUID, urlVCodeInt, selectedDeclarations) => async (dispatch) => {
//     // We start by dispatching a "request" to let Redux know we're saving
//     dispatch(saveMultipleDeclarationsRequest());
//     const total = selectedDeclarations.length;
//     let current = 0;

//     const failedDeclarations = [];
//     const successMessages = [];


//     // Iterate over each selected declaration
//     for (const declaration of selectedDeclarations) {
//         try {
//             // Build the payload for the second API
//             const payload = {
//                 ssdsshGUID,
//                 urlVcodeInt: parseInt(urlVCodeInt, 10),
//                 fullSerialNumber: declaration.FullSerialNumber,
//                 total_value: declaration.gcutotalCurrencyValue,
//                 cottage_date: declaration.gcupreDeclarationDate,
//                 quantity: declaration.gcuCommodityItemQuantity,
//                 currency_type: declaration.curNameStr,
//                 status: declaration.gcudeclarationStatus,

//             };

//          // Make the POST request using axiosInstance
//             // e.g., your backend route: 'fetch-cotage-remain-amount/'
//             const response = await axiosInstance.post('fetch-cotage-remain-amount/', payload);

//             // You can shape the success message as you wish
//             successMessages.push({
//                 FullSerialNumber: declaration.FullSerialNumber,
//                 message: response.data?.message || 'اظهارنامه با موفقیت ذخیره شد',
//             });
//         } catch (error) {
//             // On error, store the reason and the FullSerialNumber
//             let reason = 'خطای ناشناخته';
//             if (error.response && error.response.data) {
//                 // If backend sent an error message
//                 reason = error.response.data.error 
//                     || error.response.data.ErrorDesc 
//                     || JSON.stringify(error.response.data);
//             } else if (error.message) {
//                 // Generic error message from axios
//                 reason = error.message;
//             }

//             failedDeclarations.push({
//                 FullSerialNumber: declaration.FullSerialNumber,
//                 reason,
//             });
//         }

//         current += 1;
//         // Dispatch progress after each item
//         dispatch(saveMultipleDeclarationsProgress(current, total));
//     }

//     // If any failures occurred, we do partial or complete failure
//     if (failedDeclarations.length > 0) {
//         dispatch(
//             saveMultipleDeclarationsFailure({
//                 // You can store partial success data if needed
//                 failedDeclarations,
//                 successMessages, // optional, if you want to show partial success
//             })
//         );
//     } else {
//         // If everything succeeded
//         dispatch(
//             saveMultipleDeclarationsSuccess({
//                 message: 'تمام اظهارنامه‌ها با موفقیت ذخیره شدند.',
//                 successMessages,
//             })
//         );
//     }
// };

// src/actions/customsDeclarationActions.js

import axiosInstance from "../utils/axiosInstance";
import {
  FETCH_DECLARATIONS_REQUEST,
  FETCH_DECLARATIONS_SUCCESS,
  FETCH_DECLARATIONS_FAILURE,
  FETCH_DECLARATION_DETAILS_REQUEST,
  FETCH_DECLARATION_DETAILS_SUCCESS,
  FETCH_DECLARATION_DETAILS_FAILURE,
  FETCH_GOODS_REQUEST,
  FETCH_GOODS_SUCCESS,
  FETCH_GOODS_FAILURE,
  FETCH_CUSTOMS_DUTY_REQUEST,
  FETCH_CUSTOMS_DUTY_SUCCESS,
  FETCH_CUSTOMS_DUTY_FAILURE,
  SAVE_DATA_REQUEST,
  SAVE_DATA_SUCCESS,
  SAVE_DATA_FAILURE,
  SAVE_MULTIPLE_DECLARATIONS_REQUEST,
  SAVE_MULTIPLE_DECLARATIONS_SUCCESS,
  SAVE_MULTIPLE_DECLARATIONS_FAILURE,
  SAVE_MULTIPLE_DECLARATIONS_PROGRESS,
  FETCH_EXPORT_DECLARATIONS_REQUEST,
  FETCH_EXPORT_DECLARATIONS_SUCCESS,
  FETCH_EXPORT_DECLARATIONS_FAILURE,
} from "./actionTypes";

// Synchronous Action Creators
export const fetchDeclarationsRequest = () => ({
  type: FETCH_DECLARATIONS_REQUEST,
});

export const fetchDeclarationsSuccess = (declarations) => ({
  type: FETCH_DECLARATIONS_SUCCESS,
  payload: declarations,
});

export const fetchDeclarationsFailure = (error) => ({
  type: FETCH_DECLARATIONS_FAILURE,
  payload: error,
});
export const fetchExportDeclarationsRequest = () => ({
  type: FETCH_EXPORT_DECLARATIONS_REQUEST,
});

export const fetchExportDeclarationsSuccess = (declarations) => ({
  type: FETCH_EXPORT_DECLARATIONS_SUCCESS,
  payload: declarations,
});

export const fetchExportDeclarationsFailure = (error) => ({
  type: FETCH_EXPORT_DECLARATIONS_FAILURE,
  payload: error,
});

// Fetch Declaration Details Actions
export const fetchDeclarationDetailsRequest = () => ({
  type: FETCH_DECLARATION_DETAILS_REQUEST,
});

export const fetchDeclarationDetailsSuccess = (declarationDetails) => ({
  type: FETCH_DECLARATION_DETAILS_SUCCESS,
  payload: declarationDetails,
});

export const fetchDeclarationDetailsFailure = (error) => ({
  type: FETCH_DECLARATION_DETAILS_FAILURE,
  payload: error,
});

// Fetch Goods Actions
export const fetchGoodsRequest = () => ({
  type: FETCH_GOODS_REQUEST,
});

export const fetchGoodsSuccess = (goods) => ({
  type: FETCH_GOODS_SUCCESS,
  payload: goods,
});

export const fetchGoodsFailure = (error) => ({
  type: FETCH_GOODS_FAILURE,
  payload: error,
});

// Fetch Customs Duty Info Actions
export const fetchCustomsDutyRequest = (ggsVcodeInt) => ({
  type: FETCH_CUSTOMS_DUTY_REQUEST,
  payload: ggsVcodeInt,
});

export const fetchCustomsDutySuccess = (ggsVcodeInt, dutyInfo) => ({
  type: FETCH_CUSTOMS_DUTY_SUCCESS,
  payload: { ggsVcodeInt, dutyInfo },
});

export const fetchCustomsDutyFailure = (ggsVcodeInt, error) => ({
  type: FETCH_CUSTOMS_DUTY_FAILURE,
  payload: { ggsVcodeInt, error },
});

// Save Data Actions
export const saveDataRequest = () => ({
  type: SAVE_DATA_REQUEST,
});

export const saveDataSuccess = (message) => ({
  type: SAVE_DATA_SUCCESS,
  payload: message,
});

export const saveDataFailure = (error) => ({
  type: SAVE_DATA_FAILURE,
  payload: error,
});

// Save Multiple Declarations Actions
export const saveMultipleDeclarationsRequest = () => ({
  type: SAVE_MULTIPLE_DECLARATIONS_REQUEST,
});

export const saveMultipleDeclarationsSuccess = (data) => ({
  type: SAVE_MULTIPLE_DECLARATIONS_SUCCESS,
  payload: data,
});

export const saveMultipleDeclarationsFailure = (error) => ({
  type: SAVE_MULTIPLE_DECLARATIONS_FAILURE,
  payload: error,
});

export const saveMultipleDeclarationsProgress = (current, total) => ({
  type: SAVE_MULTIPLE_DECLARATIONS_PROGRESS,
  payload: { current, total },
});

// Asynchronous Action Creators

// Fetch Declarations
export const fetchDeclarations =
  (ssdsshGUID, urlVCodeInt, pageSize, startIndex) => async (dispatch) => {
    dispatch(fetchDeclarationsRequest());
    const payload = {
      ssdsshGUID,
      urlVCodeInt: parseInt(urlVCodeInt, 10),
      PageSize: parseInt(pageSize, 10),
      StartIndex: parseInt(startIndex, 10),
    };

    try {
      const response = await axiosInstance.post(
        "customs-declarations/",
        payload
      );

      if (response.data.ErrorCode === 0) {
        const declarations = Array.isArray(
          response.data.CustomizeCustomsDeclarationList
        )
          ? response.data.CustomizeCustomsDeclarationList
          : [];
        dispatch(fetchDeclarationsSuccess(declarations));
      } else {
        const errorMessage = response.data.ErrorDesc || "خطایی رخ داد. لطفاً دوباره تلاش کنید.";
        dispatch(fetchDeclarationsFailure(errorMessage));
      }
    } catch (error) {
      const errorMsg =
        error.response && error.response.data
          ? error.response.data.ErrorDesc || error.response.data
          : "ارتباط با سرور برقرار نشد.";
      dispatch(fetchDeclarationsFailure(errorMsg));
    }
  };

// Fetch Declaration Details
export const fetchDeclarationDetails =
  (FullSerialNumber, ssdsshGUID, urlVCodeInt) => async (dispatch) => {
    dispatch(fetchDeclarationDetailsRequest());
    const payload = {
      DeclarationType: 0,
      FullSerilaNumber: FullSerialNumber,
      ssdsshGUID,
      urlVCodeInt: parseInt(urlVCodeInt, 10),
    };

    try {
      const response = await axiosInstance.post(
        "customs-green-declaration/",
        payload
      );

      if (response.data.ErrorCode === 0) {
        dispatch(
          fetchDeclarationDetailsSuccess(response.data.GreenCustomsDeclaration)
        );
      } else {
        dispatch(
          fetchDeclarationDetailsFailure(
            response.data.ErrorDesc || "خطایی رخ داد. لطفاً دوباره تلاش کنید."
          )
        );
      }
    } catch (error) {
      const errorMsg =
        error.response && error.response.data
          ? error.response.data.ErrorDesc || error.response.data
          : "ارتباط با سرور برقرار نشد.";
      dispatch(fetchDeclarationDetailsFailure(errorMsg));
    }
  };

// Fetch Goods
export const fetchGoods =
  (gcuVcodeInt, ssdsshGUID, urlVCodeInt) => async (dispatch) => {
    dispatch(fetchGoodsRequest());
    const payload = {
      gcuVcodeInt,
      ssdsshGUID,
      urlVCodeInt: parseInt(urlVCodeInt, 10),
    };

    try {
      const response = await axiosInstance.post("fetch-goods/", payload);

      if (response.data.ErrorCode === 0) {
        const goods = Array.isArray(
          response.data.GreenCustomsDeclarationGoodList
        )
          ? response.data.GreenCustomsDeclarationGoodList.map((good) => ({
              ...good,
              import_rights: 0,
              red_cersent: 0,
              added_value: 0,
              discount: 0,
              customs_value: 0,
            }))
          : [];
        dispatch(fetchGoodsSuccess(goods));
      } else {
        dispatch(
          fetchGoodsFailure(response.data.ErrorDesc || "خطایی رخ داد. لطفاً دوباره تلاش کنید.")
        );
      }
    } catch (error) {
      const errorMsg =
        error.response && error.response.data
          ? error.response.data.ErrorDesc || error.response.data
          : "ارتباط با سرور برقرار نشد.";
      dispatch(fetchGoodsFailure(errorMsg));
    }
  };

// Fetch Customs Duty Information
export const fetchCustomsDutyInformation =
  (ggsVcodeInt, ssdsshGUID, urlVCodeInt) => async (dispatch) => {
    dispatch(fetchCustomsDutyRequest(ggsVcodeInt));
    const payload = {
      ggsVcodeInt,
      ssdsshGUID,
      urlVCodeInt: parseInt(urlVCodeInt, 10),
    };

    try {
      const response = await axiosInstance.post(
        "fetch-customs-duty-info/",
        payload
      );

      if (response.data.ErrorCode === 0) {
        const fetchedDutyInfo =
          response.data.GreenCustomsDutyInformationList || [];
        const dutyInfo = {
          import_rights:
            fetchedDutyInfo.find((duty) => duty.cintaxesCode === "041")
              ?.cintaxesAmount || 0,
          customs_value:
            fetchedDutyInfo.find((duty) => duty.cintaxesCode === "041")
              ?.cintaxesBase || 0,
          red_cersent:
            fetchedDutyInfo.find((duty) => duty.cintaxesCode === "042")
              ?.cintaxesAmount || 0,
          added_value:
            fetchedDutyInfo.find((duty) => duty.cintaxesCode === "047")
              ?.cintaxesAmount || 0,
          discount:
            fetchedDutyInfo.find((duty) => duty.cintaxesCode === "049")
              ?.cintaxesAmount || 0,
        };
        dispatch(fetchCustomsDutySuccess(ggsVcodeInt, dutyInfo));
        return dutyInfo;
      } else {
        dispatch(
          fetchCustomsDutyFailure(
            ggsVcodeInt,
            response.data.ErrorDesc || "خطایی رخ داد. لطفاً دوباره تلاش کنید."
          )
        );
      }
    } catch (error) {
      const errorMsg =
        error.response && error.response.data
          ? error.response.data.ErrorDesc || error.response.data
          : "ارتباط با سرور برقرار نشد.";
      dispatch(fetchCustomsDutyFailure(ggsVcodeInt, errorMsg));
    }
  };

// Save Data
export const saveData =
  (declaration, goods, ssdsshGUID, urlVCodeInt) => async (dispatch) => {
    dispatch(saveDataRequest());

    const formatDate = (dateString) => {
      if (!dateString) return null;
      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    };

    const formattedCottageDate = formatDate(
      declaration.gcupreDeclarationDateSH
    );

    const cottagePayload = {
      cottage_number: declaration.gcucustomsDeclarationSerialNumber,
      proforma: declaration.OrderRegistrationNumber,
      cottage_date: formattedCottageDate,
      cottage_payment_date: declaration.gcufinancialReceiptDateSH,
      cottage_status: declaration.DeclarationStatus,
      total_value: declaration.gcutotalCurrencyValue,
      quantity: declaration.gcucommodityItemQuantity,
      refrence_number: declaration.gculCReferenceNumber,
    };

    try {
      // Save the Cottage
      const cottageResponse = await axiosInstance.post(
        "save-cottage/",
        cottagePayload
      );

      console.log("Cottage saved:", cottageResponse.data);

      // Fetch and update duty info for all goods
      const updatedGoodsPromises = goods.map(async (good) => {
        const payload = {
          ggsVcodeInt: good.ggsVcodeInt,
          ssdsshGUID,
          urlVCodeInt: parseInt(urlVCodeInt, 10),
        };

        console.log("Sending payload to fetch-customs-duty-info:", payload);

        const response = await axiosInstance.post(
          "fetch-customs-duty-info/",
          payload
        );

        if (response.data.ErrorCode === 0) {
          const fetchedDutyInfo =
            response.data.GreenCustomsDutyInformationList || [];
          return {
            ...good,
            import_rights:
              fetchedDutyInfo.find((duty) => duty.cintaxesCode === "041")
                ?.cintaxesAmount || 0,
            customs_value:
              fetchedDutyInfo.find((duty) => duty.cintaxesCode === "041")
                ?.cintaxesBase || 0,
            red_cersent:
              fetchedDutyInfo.find((duty) => duty.cintaxesCode === "042")
                ?.cintaxesAmount || 0,
            added_value:
              fetchedDutyInfo.find((duty) => duty.cintaxesCode === "047")
                ?.cintaxesAmount || 0,
            discount:
              fetchedDutyInfo.find((duty) => duty.cintaxesCode === "049")
                ?.cintaxesAmount || 0,
          };
        } else {
          console.error(
            "Error from fetch-customs-duty-info API:",
            response.data.ErrorDesc
          );
          return good;
        }
      });

      const updatedGoods = await Promise.all(updatedGoodsPromises);

      console.log("Updated Goods with Duty Info:", updatedGoods);

      // Prepare goods payload with updated duty info
      const goodsPayload = {
        cottage_number: declaration.gcucustomsDeclarationSerialNumber,
        goods: updatedGoods.map((good) => ({
          ggsVcodeInt: good.ggsVcodeInt,
          ggscommodityItemNumber: good.ggscommodityItemNumber,
          ggscommodityDescription: good.ggscommodityDescription,
          ggscommodityHSCode: good.ggscommodityHSCode,
          total_value: good.ggscommodityItemCurrencyValue,
          import_rights: good.import_rights || 0,
          customs_value: good.customs_value || 0,
          red_cersent: good.red_cersent || 0,
          added_value: good.added_value || 0,
          discount: good.discount || 0,
          quantity: good.ggstotalItemCountInAllPackages,
          netweight: good.ggsnetWeightInKg,
          grossweight: good.ggsgrossWeightInKg,
        })),
      };

      console.log("Goods Payload:", goodsPayload);

      // Save the Goods
      const goodsResponse = await axiosInstance.post(
        "save-cottage-goods/",
        goodsPayload
      );

      dispatch(
        saveDataSuccess(
          goodsResponse.data.message || "Goods and cottage saved successfully."
        )
      );
    } catch (error) {
      console.error("Error during save operation:", error);

      const errorMsg =
        error.response && error.response.data
          ? error.response.data.ErrorDesc || JSON.stringify(error.response.data)
          : "ذخیره اطلاعات ناموفق بود.";

      dispatch(saveDataFailure(errorMsg));
    }
  };
export const saveMultipleDeclarations =
  (declarations, ssdsshGUID, urlVCodeInt) => async (dispatch, getState) => {
    dispatch(saveMultipleDeclarationsRequest({ total: declarations.length }));

    let failedDeclarations = [];
    let savedCount = 0;

    for (const [index, declaration] of declarations.entries()) {
      try {
        // Fetch declaration details
        await dispatch(
          fetchDeclarationDetails(
            declaration.FullSerialNumber,
            ssdsshGUID,
            urlVCodeInt
          )
        );
        const stateAfterDetails = getState().customsDeclarations;
        if (stateAfterDetails.errorDeclarationDetails) {
          throw new Error(
            `Failed to fetch details: ${stateAfterDetails.errorDeclarationDetails}`
          );
        }

        // Fetch goods
        await dispatch(
          fetchGoods(
            stateAfterDetails.declarationDetails.gcuVcodeInt,
            ssdsshGUID,
            urlVCodeInt
          )
        );
        const stateAfterGoods = getState().customsDeclarations;
        if (stateAfterGoods.errorGoods) {
          throw new Error(
            `Failed to fetch goods: ${stateAfterGoods.errorGoods}`
          );
        }

        // Save data
        await dispatch(
          saveData(
            stateAfterGoods.declarationDetails,
            stateAfterGoods.goods,
            ssdsshGUID,
            urlVCodeInt
          )
        );
        const finalState = getState().customsDeclarations;
        if (finalState.saveError) {
          throw new Error(`مورد ذخیره نشد: ${finalState.saveError}`);
        }

        // If everything succeeded
        savedCount++;
      } catch (error) {
        // Store both the declaration serial and the reason it failed
        failedDeclarations.push({
          FullSerialNumber: declaration.FullSerialNumber,
          reason: error.message || "An unknown error occurred.",
        });
        console.error(
          `Error saving declaration: ${declaration.FullSerialNumber}`,
          error
        );
      }

      // Update progress
      dispatch(
        saveMultipleDeclarationsProgress(index + 1, declarations.length)
      );
    }

    // Construct the final message
    let message;
    if (savedCount === declarations.length) {
      message = "All declarations saved successfully.";
    } else {
      message = `${savedCount}/${declarations.length} اضهارنامه های ثبت شده. ${failedDeclarations.length} ثبت نشده.`;
    }

    dispatch(saveMultipleDeclarationsSuccess({ message, failedDeclarations }));
  };
export const fetchExportDeclarations =
  (ssdsshGUID, urlVCodeInt, pageSize, startIndex) => async (dispatch) => {
    dispatch(fetchExportDeclarationsRequest());
    const payload = {
      ssdsshGUID,
      urlVCodeInt: parseInt(urlVCodeInt, 10),
      PageSize: parseInt(pageSize, 10),
      StartIndex: parseInt(startIndex, 10),
    };

    try {
      const response = await axiosInstance.post(
        "export-customs-declarations/",
        payload
      );

      if (response.data.ErrorCode === 0) {
        const declarations = Array.isArray(
          response.data.CustomizeCustomsDeclarationList
        )
          ? response.data.CustomizeCustomsDeclarationList
          : [];
        dispatch(fetchExportDeclarationsSuccess(declarations));
      } else {
        const errorMessage = response.data.ErrorDesc || "خطایی رخ داد. لطفاً دوباره تلاش کنید.";
        dispatch(fetchExportDeclarationsFailure(errorMessage));
      }
    } catch (error) {
      const errorMsg =
        error.response && error.response.data
          ? error.response.data.ErrorDesc || error.response.data
          : "ارتباط با سرور برقرار نشد.";
      dispatch(fetchExportDeclarationsFailure(errorMsg));
    }
  };
// New Action Creator: Save Multiple Declarations
export const saveSelectedDeclarations =
  (ssdsshGUID, urlVCodeInt, selectedDeclarations) => async (dispatch) => {
    // We start by dispatching a "request" to let Redux know we're saving
    dispatch(saveMultipleDeclarationsRequest());
    const total = selectedDeclarations.length;
    let current = 0;

    const failedDeclarations = [];
    const successMessages = [];

    // Iterate over each selected declaration
    for (const declaration of selectedDeclarations) {
      try {
        // Build the payload for the second API
        const payload = {
          ssdsshGUID,
          urlVcodeInt: parseInt(urlVCodeInt, 10),
          fullSerialNumber: declaration.FullSerialNumber,
          total_value: declaration.gcutotalCurrencyValue,
          cottage_date: declaration.gcupreDeclarationDate,
          quantity: declaration.gcuCommodityItemQuantity,
          currency_type: declaration.curNameStr,
          status: declaration.gcudeclarationStatus,
        };

        // Make the POST request using axiosInstance
        // e.g., your backend route: 'fetch-cotage-remain-amount/'
        const response = await axiosInstance.post(
          "fetch-cotage-remain-amount/",
          payload
        );

        // You can shape the success message as you wish
        successMessages.push({
          FullSerialNumber: declaration.FullSerialNumber,
          message: response.data?.message || "اظهارنامه با موفقیت ذخیره شد",
        });
      } catch (error) {
        // On error, store the reason and the FullSerialNumber
        let reason = "خطای ناشناخته";
        if (error.response && error.response.data) {
          // If backend sent an error message
          reason =
            error.response.data.error ||
            error.response.data.ErrorDesc ||
            JSON.stringify(error.response.data);
        } else if (error.message) {
          // Generic error message from axios
          reason = error.message;
        }

        failedDeclarations.push({
          FullSerialNumber: declaration.FullSerialNumber,
          reason,
        });
      }

      current += 1;
      // Dispatch progress after each item
      dispatch(saveMultipleDeclarationsProgress(current, total));
    }

    // If any failures occurred, we do partial or complete failure
    if (failedDeclarations.length > 0) {
      dispatch(
        saveMultipleDeclarationsFailure({
          // You can store partial success data if needed
          failedDeclarations,
          successMessages, // optional, if you want to show partial success
        })
      );
    } else {
      // If everything succeeded
      dispatch(
        saveMultipleDeclarationsSuccess({
          message: "تمام اظهارنامه‌ها با موفقیت ذخیره شدند.",
          successMessages,
        })
      );
    }
  };
